import {
  Box,
  Stack,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Button,
  Typography,
  Divider,
} from '@mui/material'
import { DialogCloseButton } from 'components/DialogCloseButton'
import { useTranslation } from 'react-i18next'
import { INotification } from 'types/notification'

type Props = {
  notification: INotification
  onClose: () => void
}

export const DialogNotificationPreview = ({ notification, onClose }: Props) => {
  const { t } = useTranslation()

  return (
    <Dialog
      PaperProps={{ sx: { minWidth: '300px' } }}
      open
      fullWidth
      onClose={onClose}
    >
      <DialogTitle>{t('notification')}</DialogTitle>
      <DialogCloseButton handleClose={onClose} />

      <Divider />

      <DialogContent>
        <Stack spacing={3}>
          <Stack>
            <Typography variant="body2" fontWeight="bold">
              {t('organization')}
            </Typography>
            <Typography variant="body2">{notification.organizationName}</Typography>
          </Stack>

          <Box>
            <Typography variant="body2" fontWeight="bold">
              {t('fullName')}
            </Typography>
            <Typography variant="body2">{notification.personalName}</Typography>
          </Box>

          <Stack direction="row" spacing={3}>
            <Box>
              <Typography variant="body2" fontWeight="bold">
                {t('email-address')}
              </Typography>
              <Typography variant="body2">{notification.email}</Typography>
            </Box>
            <Box>
              <Typography variant="body2" fontWeight="bold">
                {t('phoneNumber')}
              </Typography>
              <Typography variant="body2">{notification.phoneNumber}</Typography>
            </Box>
          </Stack>

          <Box>
            <Typography variant="body2" fontWeight="bold">
              {t('description')}
            </Typography>
            <Typography variant="body2">{notification.messageBody}</Typography>
          </Box>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Stack width="100%" direction="row" justifyContent="center">
          <Button onClick={onClose} variant="outlined">
            {t('close')}
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  )
}
